import { BaseDto } from '@/shared/dtos/base-dto';

export class fichajes_empleado_historial extends BaseDto {
    public fichaje_id !: number;
    public campo_modificado !: string;
    public valor_anterior !: string;
    public valor_nuevo !: string;
 } 
